module.exports = __webpack_public_path__ + "static/img/wealth_level_58.56f4fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_58.png
// module id = gZi7
// module chunks = 0